@if (jobDeetsForm != null) {
  <div class="tab-wrapper" id="job-details-tab-wrapper">
    <form [formGroup]="jobDeetsForm">
      <div class="row">
        <div class="col-xl-6" *ngIf="authService.canRead('employee_job_details_panel')">
          <div class="card" [ngClass]="{ 'expanded-card': cardExpanders['jobDetails'] }">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('jobDetails')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['jobDetails'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title">Job Details</h3>
              <div class="row" *hasPermission="'employee_job_details_id'">
                <div class="col-lg-12">
                  <label>ID</label>
                  <input
                    appAutoFocus
                    formControlName="EmployeeId"
                    class="form-control"
                    maxlength="4"
                    autofocus />
                  <div
                    *ngIf="f.EmployeeId.errors?.maxlength || f.EmployeeId.errors?.pattern"
                    class="input-error">
                    *invalid Id
                  </div>
                  <div *ngIf="f.EmployeeId.errors?.required" class="input-error">*required</div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div *hasPermission="'employee_job_details_hire_date'">
                    <label>Hire Date</label>
                    <div class="input-group">
                      <input
                        formControlName="HireDate"
                        class="form-control datepicker"
                        [firstDayOfWeek]="7"
                        [placement]="['bottom-end', 'top-end']"
                        ngbDatepicker
                        #hiredatepicker="ngbDatepicker"
                        [maxDate]="maxDate" />
                      <div
                        *ngIf="f.HireDate.errors?.required"
                        class="input-error input-group-error">
                        *required
                      </div>
                      <div
                        *ngIf="!f.HireDate.valid && !f.HireDate.errors?.required"
                        class="input-error input-group-error">
                        *invalid date
                      </div>
                      <img
                        src="assets/icons/calendar.svg"
                        (click)="hiredatepicker.toggle()"
                        class="icon-append" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div *hasPermission="'employee_job_details_report_as_new_hire'">
                    <label>Report As New Hire</label>
                    <div class="radio-group">
                      <div>
                        <input
                          type="radio"
                          id="new-hire-radio-no"
                          formControlName="ShouldReportAsNewHire"
                          name="ShouldReportAsNewHire"
                          value="0" />
                        <label for="new-hire-radio-no"><span></span>No</label>
                      </div>
                      <div class="radio-options-spacer"></div>
                      <div>
                        <input
                          type="radio"
                          id="new-hire-radio-yes"
                          formControlName="ShouldReportAsNewHire"
                          name="ShouldReportAsNewHire"
                          value="1"
                          [attr.disabled]="
                            !(client | async).UseNewHireReporting ? 'disabled' : null
                          " />
                        <label for="new-hire-radio-yes"><span></span>Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div *hasPermission="'employee_job_details_works_in'">
                    <label>Works in</label>
                    <select formControlName="WorksIn" class="form-control">
                      <option></option>
                      <option *ngFor="let state of availableStates" value="{{ state.Id }}">
                        {{ state.Value }}
                      </option>
                    </select>
                    <div *ngIf="f.WorksIn.errors?.required" class="input-error">*required</div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div *hasPermission="'employee_job_details_pay_automatically'">
                    <label>Pay Automatically</label>
                    <div class="radio-group">
                      <div>
                        <input
                          type="radio"
                          id="auto-pay-no"
                          formControlName="OKToAutoPay"
                          name="OKToAutoPay"
                          value="0" />
                        <label for="auto-pay-no"><span></span>No</label>
                      </div>
                      <div class="radio-options-spacer"></div>
                      <div>
                        <input
                          type="radio"
                          id="auto-pay-yes"
                          formControlName="OKToAutoPay"
                          name="OKToAutoPay"
                          value="1" />
                        <label for="auto-pay-yes"><span></span>Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_job_details_location'">
                <!--
                  if there is only 1 location with id 0 ('Main'), the client is not setup for locations.
                  hide the locations control but still use its associated pay frequencies
                -->
                <div
                  class="col-lg-6"
                  *ngIf="
                    (locations | async).length > 1 ||
                    ((locations | async).length === 1 && (getFirstLocation() | async).Id !== 0)
                  ">
                  <label>Location</label>
                  <select formControlName="Location" class="form-control">
                    <option *ngFor="let loc of locations | async" value="{{ loc.Id }}">
                      {{ loc.Code }} - {{ loc.Name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_job_details_pay_frequency'">
                <div class="col-lg-12">
                  <label>Pay Schedule/Frequency</label>
                  <select
                    formControlName="PayFrequency"
                    class="form-control"
                    (ngModelChange)="onPayFrequencyChange()">
                    <option *ngFor="let cal of calendars" value="{{ cal.Frequency }}">
                      {{ cal.CalendarName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" *ngIf="divisions && divisions.length > 0">
                <div
                  class="col-lg-6"
                  *ngIf="divisions.length > 1 || (divisions.length === 1 && divisions[0].Id !== 0)">
                  <div *hasPermission="'employee_job_details_division'">
                    <label>Division</label>
                    <select
                      formControlName="Division"
                      class="form-control"
                      (change)="onDivisionChange()">
                      <option *ngFor="let div of divisions" value="{{ div.Id }}">
                        <ng-container *ngIf="div.Id != 0; else blankDivision">
                          {{ div.DisplayId }} - {{ div.Name }}
                        </ng-container>
                        <ng-template #blankDivision> </ng-template>
                      </option>
                    </select>
                    <div *ngIf="f.Division.errors?.required" class="input-error">*required</div>
                  </div>
                </div>
                <div
                  [ngClass]="
                    divisions.length > 1 || (divisions.length === 1 && divisions[0].Id !== 0)
                      ? 'col-lg-6'
                      : 'col-lg-12'
                  ">
                  <div *hasPermission="'employee_job_details_department'">
                    <label>Department</label>
                    <select
                      formControlName="Department"
                      class="form-control"
                      [attr.disabled]="!departments || departments.length == 0 ? 'disabled' : null">
                      <option *ngFor="let dept of departments" value="{{ dept.Id }}">
                        {{ dept.DisplayId }} - {{ dept.Value }}
                      </option>
                    </select>
                    <div *ngIf="f.Department.errors?.required" class="input-error">*required</div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_job_details_job_title'">
                <div class="col-lg-12">
                  <label>Job Title</label>
                  <input formControlName="JobTitle" class="form-control" />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div *hasPermission="'employee_job_details_seasonal_employee'">
                    <label>Seasonal Employee</label><br />
                    <input
                      formControlName="IsSeasonal"
                      type="checkbox"
                      id="checkbox-seasonal"
                      value="true" />
                    <label for="checkbox-seasonal"><span></span>Yes</label><br />
                  </div>
                </div>
                <div class="col-lg-6" *ngIf="(employmentTypeId | async) != employmentTypes.M1099">
                  <div *hasPermission="'employee_job_details_owner_officer'">
                    <label>Owner/Officer</label><br />
                    <input
                      formControlName="IsOwnerOfficer"
                      type="checkbox"
                      id="checkbox-officer"
                      value="true"
                      checked="" />
                    <label for="checkbox-officer"><span></span>Yes</label><br />
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_job_details_full_time_part_time'">
                <div class="col-lg-12">
                  <label>Full Time/Part Time</label>
                  <select formControlName="FullTimePartTime" class="form-control">
                    <option value="F">Full Time</option>
                    <option value="P">Part Time</option>
                  </select>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_job_details_basis_of_payment'">
                <div class="col-lg-12">
                  <label>Basis of Payment</label>
                  <select class="form-control" formControlName="BasisOfPayment">
                    <option *ngFor="let pmts of basisOfPayments" value="{{ pmts.Id }}">
                      {{ pmts.Value }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_job_details_occupation'">
                <div class="col-lg-12">
                  <label>Occupation</label>
                  <select
                    class="form-control"
                    formControlName="OccupationId"
                    (change)="onOccupationChange()">
                    <option *ngFor="let occupation of occupations" value="{{ occupation.Id }}">
                      {{ occupation.Value }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_job_details_soc_code'">
                <div class="col-lg-12">
                  <label>SOC Code</label>
                  <select class="form-control" formControlName="SOCCode">
                    <option *ngFor="let code of soccodes" value="{{ code.Id }}">
                      <span *ngIf="code.Id">{{ code.Id }} - {{ code.Value }}</span>
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_job_details_work_phone_number'">
                <div class="col-lg-6">
                  <label>Work Phone Number</label>
                  <input
                    formControlName="WorkPhoneNumber"
                    class="form-control"
                    type="tel"
                    mask="(000) 000 - 0000"
                    placeholder="( ___ ) ___ - ____" />
                  <div *ngIf="f.WorkPhoneNumber.errors" class="input-error">
                    *invalid phone number
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_job_details_work_email_address'">
                <div class="col-lg-12">
                  <label>Work Email Address</label>
                  <input formControlName="WorkEmailAddress" class="form-control" type="email" />
                  <div *ngIf="f.WorkEmailAddress.errors?.pattern" class="input-error">
                    *Must be in format name&#64;example.nn
                  </div>

                  <div *ngIf="f.WorkEmailAddress.errors?.blacklistedDomain" class="input-error">
                    *{{ f.WorkEmailAddress.errors?.blacklistedDomain }} is an invalid domain. Please
                    enter a different email address.
                  </div>
                </div>
              </div>

              <div class="row" *hasPermission="'employee_job_details_original_hire_date'">
                <div class="col-lg-6">
                  <label>Original Hire Date</label>
                  <div class="input-group">
                    <input
                      formControlName="OriginalHireDate"
                      [firstDayOfWeek]="7"
                      [maxDate]="hireDate"
                      [placement]="['bottom-end', 'top-end']"
                      class="form-control datepicker"
                      ngbDatepicker
                      #oghiredatepicker="ngbDatepicker" />
                    <div
                      *ngIf="!f.OriginalHireDate.valid"
                      class="input-error input-group-error show-untouched">
                      *{{ getOGHireDateErrorMsg(f.OriginalHireDate.value, hireDate) }}
                    </div>
                    <img
                      src="assets/icons/calendar.svg"
                      (click)="oghiredatepicker.toggle()"
                      class="icon-append" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-xl-6">
          <div
            class="card"
            [ngClass]="{ 'expanded-card': cardExpanders['employmentHistory'] }"
            *ngIf="authService.canRead('employee_employment_history_panel')">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('employmentHistory')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['employmentHistory'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <div class="float-end">
                <button
                  type="button"
                  class="btn btn-primary"
                  cpGTagEvent
                  [params]="{ event_label: 'people_edit_update_employment_status' }"
                  (click)="addStatus(content)"
                  [disabled]="readOnly | async"
                  *ngIf="(person | async).Id">
                  Update Status
                </button>
              </div>
              <h3 class="card-title">Employment History</h3>
              <div *ngIf="authService.canRead('employee_status_panel')">
                <table class="table table-hover expand-rows" style="margin-bottom: 20px">
                  <thead>
                    <tr>
                      <th style="width: 50px"></th>
                      <th>Status</th>
                      <th>Effective Date</th>
                      <th>Reason</th>
                      <th style="width: 50px"></th>
                    </tr>
                  </thead>
                  <tbody
                    *ngIf="
                      (person | async).Id && (statuses | async) && (statuses | async).length > 0
                    ">
                    <tr>
                      <td *ngIf="(statuses | async).length > 1" (click)="collapseStatuses()">
                        <span
                          [className]="
                            statusesCollapsed ? 'collapse-icon' : 'collapse-icon open'
                          "></span>
                      </td>
                      <td *ngIf="(statuses | async).length === 1"></td>
                      <td>{{ statusDescriptions[(getCurrentStatus() | async).StatusId] }}</td>
                      <td>
                        {{ (getCurrentStatus() | async).DateStatusChange | date: 'MM/dd/yyyy' }}
                      </td>
                      <td style="white-space: normal">
                        {{ getReasonValue((getCurrentStatus() | async).ReasonSequenceNumber) }}
                      </td>
                      <td>
                        <a (click)="editStatus(getCurrentStatus(), content)">
                          {{ (readOnly | async) ? 'View' : 'Edit' }}
                        </a>
                      </td>
                    </tr>
                    <tr
                      *ngFor="let st of getPastStatuses() | async"
                      class="sub-row"
                      [ngbCollapse]="statusesCollapsed">
                      <td></td>
                      <td>{{ statusDescriptions[st.StatusId] }}</td>
                      <td>{{ st.DateStatusChange | date: 'MM/dd/yyyy' }}</td>
                      <td style="white-space: normal">
                        {{ getReasonValue(st.ReasonSequenceNumber) }}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="!(person | async).Id">
                    <tr>
                      <td></td>
                      <td>Active</td>
                      <td>{{ today | date: 'MM/dd/yyyy' }}</td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            class="card"
            [ngClass]="{ 'expanded-card': cardExpanders['workersComp'] }"
            *ngIf="
              authService.canRead('employee_workers_comp_panel') &&
              (client | async).HasWorkersCompensation &&
              worksInState
            ">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('workersComp')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['workersComp'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title">Workers Compensation</h3>
              <div class="row" *hasPermission="'employee_workers_comp_include_in_workers_comp'">
                <div class="col-lg-10" *ngIf="(employmentTypeId | async) != employmentTypes.W2">
                  <label> Include this person in Workers Compensation Reporting? </label><br />
                  <input
                    formControlName="IncludeNonW2InWorkersComp"
                    type="checkbox"
                    id="checkbox-includewc"
                    value="true" />
                  <label for="checkbox-includewc"><span></span>Yes</label><br />
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-12"
                  *ngIf="
                    (employmentTypeId | async) == employmentTypes.W2 ||
                    f.IncludeNonW2InWorkersComp.value
                  ">
                  <label>Working In</label>
                  <div class="mb-3">{{ worksInState }}</div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_workers_comp_code'">
                <div
                  class="col-lg-12"
                  *ngIf="
                    (employmentTypeId | async) == employmentTypes.W2 ||
                    f.IncludeNonW2InWorkersComp.value
                  ">
                  <label>Workers Compensation Code</label>
                  <select class="form-control" formControlName="WorkersCompCode">
                    <option *ngFor="let code of availableCompCodes" value="{{ code.Code }}">
                      {{ code.Code }} - {{ code.Description }}
                    </option>
                  </select>
                  <div
                    *ngIf="f.WorkersCompCode.errors?.required && availableCompCodes.length > 0"
                    class="input-error">
                    *required
                  </div>
                  <div
                    *ngIf="
                      availableCompCodes.length == 0 && (client | async).RequiresWorkersCompCodes
                    "
                    class="input-error show-untouched">
                    Workers Compensation codes for {{ worksInState }} must be added to the Company
                    Workers Compensation codes list
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-12"
                  *ngIf="
                    workersCompRate &&
                    ((employmentTypeId | async) == employmentTypes.W2 ||
                      f.IncludeNonW2InWorkersComp.value)
                  ">
                  <p>Rate: {{ workersCompRate }}</p>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_workers_comp_owner_status'">
                <div
                  class="col-lg-12"
                  *ngIf="
                    (employmentTypeId | async) == employmentTypes.W2 ||
                    ((employmentTypeId | async) == employmentTypes.K1 &&
                      f.IncludeNonW2InWorkersComp.value)
                  ">
                  <label>This person is</label>
                  <div class="radio-group row">
                    <div class="col-sm-12 col-lg-6">
                      <input
                        type="radio"
                        id="not-owner-office-radio"
                        formControlName="WorkersCompOwnerStatus"
                        name="WorkersCompOwnerStatus"
                        value="1"
                        [attr.disabled]="f.IsOwnerOfficer.value ? 'disabled' : null" />
                      <label for="not-owner-office-radio"><span></span>Not an owner/officer</label>
                      &nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="col-lg-6">
                      <input
                        type="radio"
                        id="non-participating-radio"
                        formControlName="WorkersCompOwnerStatus"
                        name="WorkersCompOwnerStatus"
                        value="2"
                        [attr.disabled]="!f.IsOwnerOfficer.value ? 'disabled' : null" />
                      <label for="non-participating-radio"
                        ><span></span>Non-participating owner/officer</label
                      >
                      &nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="col-lg-6">
                      <input
                        type="radio"
                        id="participating-no-limit-radio"
                        formControlName="WorkersCompOwnerStatus"
                        name="WorkersCompOwnerStatus"
                        value="3"
                        [attr.disabled]="!f.IsOwnerOfficer.value ? 'disabled' : null" />
                      <label for="participating-no-limit-radio"
                        ><span></span>Participating owner/officer with no limit</label
                      >
                    </div>
                    <div class="col-lg-6">
                      <input
                        type="radio"
                        id="participating-limit-radio"
                        formControlName="WorkersCompOwnerStatus"
                        name="WorkersCompOwnerStatus"
                        value="4"
                        [attr.disabled]="
                          !f.IsOwnerOfficer.value || disableParticipatingLimit ? 'disabled' : null
                        " />
                      <label for="participating-limit-radio"
                        ><span></span>Participating owner/officer with limit
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-12"
                  *ngIf="
                    ((employmentTypeId | async) == employmentTypes.W2 ||
                      f.IncludeNonW2InWorkersComp.value) &&
                    f.WorkersCompOwnerStatus.value == 4 &&
                    organizationType
                  ">
                  Organization Type: {{ organizationType }}
                </div>
              </div>
              <div class="row" *hasPermission="'employee_wokers_comp_limit_id'">
                <div
                  class="col-lg-12"
                  *ngIf="
                    ((employmentTypeId | async) == employmentTypes.W2 ||
                      f.IncludeNonW2InWorkersComp.value) &&
                    f.WorkersCompOwnerStatus.value == 4
                  ">
                  <label>{{ worksInState }} Limit</label>
                  <select class="form-control" formControlName="WorkersCompLimitId">
                    <option *ngFor="let limit of availableStateLimits" value="{{ limit.Id }}">
                      {{ limit.Description }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div
            class="card"
            [ngClass]="{ 'expanded-card': cardExpanders['laborAllocations'] }"
            *ngIf="
              authService.canRead('employee_labor_allocation_panel') &&
              (client | async).LaborAllocationType != 0
            ">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('laborAllocations')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['laborAllocations'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <div class="float-end">
                <button
                  type="button"
                  class="btn btn-outline-link"
                  cpGTagEvent
                  [params]="{ event_label: 'people_edit_view_allocation_history' }"
                  (click)="viewAllocationHistory(allocationHistoryModal)"
                  *ngIf="allocationHistory && allocationHistory.length > 0 && (person | async).Id">
                  View History
                </button>
                &nbsp;&nbsp;&nbsp;
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="addAllocation(allocationModal)"
                  cpGTagEvent
                  [params]="{ event_label: 'people_edit_add_allocation' }"
                  [attr.disabled]="totalLaborAllocation >= 100 ? 'disabled' : null">
                  <i class="fas fa-xs fa-plus"></i>&nbsp; Allocation Rule
                </button>
              </div>
              <h3 class="card-title">Labor Allocation</h3>
              <div
                *ngIf="f.LaborAllocationTotal.errors?.required && f.LaborAllocationTotal.touched"
                style="color: #ff4300; position: absolute; top: 55px">
                *Allocations must equal 100%
              </div>
              <div *ngIf="!(laborAllocations | async) || (laborAllocations | async).length == 0">
                <em>No allocations...</em>
              </div>
              <table
                class="table table-hover"
                style="table-layout: fixed"
                *ngIf="(laborAllocations | async) && (laborAllocations | async).length > 0">
                <thead>
                  <tr>
                    <th>
                      {{ laborAllocationTypes[(client | async).LaborAllocationType] }} & Description
                    </th>
                    <th class="align-right">Percentage of Gross Pay</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let la of laborAllocations | async">
                    <td class="text-wrap">{{ getJobCodeDescription(la.JobCodeId) | async }}</td>
                    <td class="align-right">{{ la.PercentageOfGrossPay | number: '1.2-2' }}%</td>
                    <td class="align-right">
                      <ng-container *ngIf="!(readOnly | async)">
                        <button
                          cpGTagEvent
                          [params]="{ event_label: 'people_edit_delete_allocation' }"
                          class="btn btn-link"
                          (click)="deleteAllocation(la)">
                          Delete
                        </button>
                        &nbsp;|&nbsp;
                      </ng-container>
                      <button
                        cpGTagEvent
                        [params]="{ event_label: 'people_edit_edit_allocation' }"
                        class="btn btn-link"
                        (click)="editAllocation(la, allocationModal)">
                        {{ (readOnly | async) ? 'View' : 'Edit' }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Status</h4>
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_status_modal_dismiss' }"
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form
        [formGroup]="statusModalForm"
        class="padded-form"
        [ngClass]="{ readOnly: (readOnly | async) }">
        <div class="row" *hasPermission="'employee_status_status_id'">
          <div class="col-lg-12">
            <label>Status</label>
            <select formControlName="Status" class="form-control">
              <option *ngFor="let st of availableStatuses" value="{{ st.Id }}">
                {{ st.Value }}
              </option>
            </select>
            <div *ngIf="s.Status.errors?.required" class="input-error">*required</div>
          </div>
        </div>
        <div class="row" *hasPermission="'employee_status_date'">
          <div class="col-lg-12">
            <label>Status Date</label>
            <div class="input-group">
              <input
                formControlName="DateStatusChange"
                class="form-control datepicker"
                ngbDatepicker
                [placement]="['bottom-end', 'top-end']"
                #sdp="ngbDatepicker"
                [firstDayOfWeek]="7"
                [minDate]="statusMinDate" />
              <div
                *ngIf="s.DateStatusChange.errors?.required"
                class="input-error input-group-error">
                *required
              </div>
              <div
                *ngIf="!s.DateStatusChange.errors?.required && !s.DateStatusChange.valid"
                class="input-error input-group-error">
                *invalid date
              </div>
              <img src="assets/icons/calendar.svg" (click)="sdp.toggle()" class="icon-append" />
            </div>
          </div>
        </div>
        <div class="row" *hasPermission="'employee_status_reason'">
          <div class="col-lg-12">
            <label>Reason</label>
            <select formControlName="Reason" class="form-control">
              <option></option>
              <option *ngFor="let reason of employeeStatusReasons" value="{{ reason.Id }}">
                {{ reason.Value }}
              </option>
            </select>
            <div *ngIf="s.Reason.errors?.required" class="input-error">*required</div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_status_modal_cancel' }"
        type="button"
        class="btn btn-secondary"
        (click)="modal.dismiss()">
        Cancel
      </button>
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_status_modal_save' }"
        type="button"
        class="btn btn-primary"
        (click)="modal.close()"
        [disabled]="!statusModalForm.valid || (readOnly | async)">
        Save Status
      </button>
    </div>
    <div class="text-end pb-2 pe-3" *ngIf="readOnly | async">
      <strong
        ><em>{{ clientLockMsg }}</em></strong
      >
    </div>
  </ng-template>
  <ng-template #allocationModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Labor Allocation</h4>
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_labor_modal_dismiss' }"
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form
        [formGroup]="allocationModalForm"
        class="padded-form"
        [ngClass]="{ readOnly: (readOnly | async) }">
        <div class="card" *ngIf="jobCodeAddMode">
          <div class="card-body">
            <div class="row" *hasPermission="'employee_labor_allocation_job_code'">
              <div class="col-lg-12">
                <label>{{ laborAllocationTypes[(client | async).LaborAllocationType] }}</label>
                <input
                  class="form-control"
                  formControlName="JobCodeId"
                  appNumberInput
                  [decimals]="0"
                  [attr.disabled]="a.JobCodeId.disabled ? 'disabled' : null" />
              </div>
            </div>
            <div class="row" *hasPermission="'employee_labor_allocation_description'">
              <div class="col-lg-12">
                <label>Description</label>
                <input class="form-control" formControlName="Description" />
              </div>
            </div>
            <button
              class="btn btn-primary"
              style="float: right"
              cpGTagEvent
              [params]="{ event_label: 'people_edit_labor_modal_save_new_job_code' }"
              [attr.disabled]="!a.JobCodeId.value || !a.Description.value ? 'disabled' : null"
              (click)="saveNewJobCode()">
              Save {{ laborAllocationTypes[(client | async).LaborAllocationType] }}
            </button>
          </div>
        </div>
        <div class="row" *hasPermission="'employee_labor_allocation_job_code'">
          <div class="col-lg-12" *ngIf="!jobCodeAddMode">
            <label
              >{{ laborAllocationTypes[(client | async).LaborAllocationType] }}/Description</label
            >
            <div class="ng-autocomplete" *ngIf="!jobCodeAddMode">
              <ng-autocomplete
                #auto
                formControlName="JobCodeId"
                [data]="availableJobCodes"
                [selectedValueRender]="selValueRender"
                [searchKeyword]="keyword"
                (selected)="onJobCodeSelect()"
                (inputChanged)="onJobCodeChange($event)"
                (inputFocused)="onJobCodeFocused()"
                [itemTemplate]="itemTemplate"
                [notFoundTemplate]="notFoundTemplate">
              </ng-autocomplete>
              <ng-template #itemTemplate let-item>
                <a [innerHTML]="item.Value"></a>
              </ng-template>
              <ng-template #notFoundTemplate let-notFound>
                <a
                  (click)="addNewJobCode()"
                  *ngIf="(client | async).LaborAllocationType == laborAllocationTypes['Job Code']">
                  <strong
                    >Add New
                    {{ laborAllocationTypes[(client | async).LaborAllocationType] }}</strong
                  >
                </a>
                <span
                  *ngIf="(client | async).LaborAllocationType != laborAllocationTypes['Job Code']">
                  <strong>No results found</strong>
                </span>
              </ng-template>
            </div>
            <div *ngIf="a.JobCodeId.errors?.required && a.JobCodeId.touched" class="input-error">
              *required
            </div>
            <div
              *ngIf="a.JobCodeId.value && !isJobCodeValid && a.JobCodeId.touched"
              class="input-error">
              *invalid {{ laborAllocationTypes[(client | async).LaborAllocationType] }} Id
            </div>
          </div>
        </div>
        <div class="row" *hasPermission="'employee_labor_allocation_percentage_of_gross_pay'">
          <div class="col-lg-12">
            <label>Percentage of Gross Pay</label>
            <div class="input-group">
              <input
                appNumberInput
                formControlName="PercentageOfGrossPay"
                class="form-control"
                [attr.disabled]="
                  a.PercentageOfGrossPay.disabled || jobCodeAddMode ? 'disabled' : null
                "
                (keyup)="setCurrentLaborAllocations($event)" />
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
              <div
                *ngIf="a.PercentageOfGrossPay.errors?.required"
                class="input-error input-group-error">
                *required
              </div>
              <div *ngIf="a.PercentageOfGrossPay.errors?.max" class="input-error input-group-error">
                *total allocations cannot exceed 100%
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_labor_modal_cancel' }"
        type="button"
        class="btn btn-secondary"
        (click)="modal.dismiss()">
        Cancel
      </button>
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_labor_modal_continue' }"
        *ngIf="currentLaborAllocations < 100"
        type="button"
        class="btn btn-primary"
        (click)="continueAllocations()"
        [disabled]="disableAllocationSave() || (readOnly | async)">
        Continue
      </button>
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_labor_modal_save' }"
        *ngIf="currentLaborAllocations >= 100"
        type="button"
        class="btn btn-primary"
        (click)="modal.close()"
        [disabled]="disableAllocationSave() || (readOnly | async)">
        Save Allocation
      </button>
    </div>
    <div class="text-end pb-2 pe-3" *ngIf="readOnly | async">
      <strong
        ><em>{{ clientLockMsg }}</em></strong
      >
    </div>
  </ng-template>
  <ng-template #allocationHistoryModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Labor Allocation Change History</h4>
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_history_modal_dismiss' }"
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="!allocationHistory || allocationHistory.length == 0">
        <em>No history...</em>
      </div>
      <table class="table table-hover" *ngIf="allocationHistory && allocationHistory.length > 0">
        <thead>
          <tr>
            <th sortable="JobCodeId" (sort)="onSort($event)">
              {{ laborAllocationTypes[(client | async).LaborAllocationType] }}
            </th>
            <th sortable="Description" (sort)="onSort($event)">Description</th>
            <th>New Value</th>
            <th>Old Value</th>
            <th sortable="ChangedBy" (sort)="onSort($event)">Changed by</th>
            <th sortable="ChangedOn" (sort)="onSort($event)">Change Date/Time</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of allocationHistory">
            <td>{{ (getJobCodeDescription(row.JobCodeId) | async).split('-')[0].trim() }}</td>
            <td>{{ getJobCodeDescription(row.JobCodeId, true) | async }}</td>
            <td *ngIf="row.NewValue">{{ row.NewValue | number: '1.2-2' }}%</td>
            <td *ngIf="!row.NewValue"></td>
            <td *ngIf="row.OldValue">{{ row.OldValue | number: '1.2-2' }}%</td>
            <td *ngIf="!row.OldValue"></td>
            <td>{{ row.ChangedBy }}</td>
            <td>{{ row.ChangedOn | date: 'MM/dd/yyyy h:mma' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-footer">
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_history_modal_close' }"
        type="button"
        class="btn btn-secondary"
        (click)="modal.dismiss()">
        Close
      </button>
    </div>
  </ng-template>
}
